module.exports = __webpack_public_path__ + "img/TSY_02_03.150fa1ba.png";